export const SET_STEP: string = "set_step"